import { Route, Routes, Navigate } from "react-router-dom";

import Home from "../pages/Home/Home";
import Login from "../pages/Login/Login";
import Error from "../pages/Error/Error";
import Deprecated from "../pages/Deprecated/Deprecated";
import FincompayApp from "../pages/FincompayApp/FincompayApp";
import Policy from "../pages/Policy/Policy";

type Props = {};

const isNewFincompayHost = () =>
  typeof window !== "undefined" &&
  window.location.hostname === "new.fincompay.com";

const Routing = (props: Props) => {
  const RootPage = isNewFincompayHost() ? FincompayApp : Home;

  return (
    <Routes>
      <Route path="/" element={<RootPage />} />
      <Route path="/personal" element={<Deprecated />} />
      <Route path="/error" element={<Error />} />
      <Route path="/ob/login" element={<Login />} />
      <Route path="/resurces/privacy_policy" element={<Policy />} />
      <Route path="*" element={<Navigate replace to="/" />} />
    </Routes>
  );
};

export default Routing;
